export const lifeGallery = [
  {
    cap: 'Shared meals',
    alt: 'Friends sharing lunch around a long wooden table',
    img: 'https://public.readdy.ai/ai/img_res/sandbox/d9f57693db1a3f647bcb80a40a4edde0/5fa7b452-069c-4ae4-8f43-36e8851e8c88_dw-lh-g1.webp',
  },
  {
    cap: 'Outdoor walks',
    alt: 'Older man walking with a friend in a park',
    img: 'https://public.readdy.ai/ai/img_res/sandbox/d9f57693db1a3f647bcb80a40a4edde0/5fa7b452-069c-4ae4-8f43-36e8851e8c88_dw-lh-g2.webp',
  },
  {
    cap: 'Creative afternoons',
    alt: 'Older woman painting watercolours at a table',
    img: 'https://public.readdy.ai/ai/img_res/sandbox/d9f57693db1a3f647bcb80a40a4edde0/5fa7b452-069c-4ae4-8f43-36e8851e8c88_dw-lh-g3.webp',
  },
  {
    cap: 'Quiet moments',
    alt: 'Older man relaxing with a book in an armchair',
    img: 'https://public.readdy.ai/ai/img_res/sandbox/d9f57693db1a3f647bcb80a40a4edde0/5fa7b452-069c-4ae4-8f43-36e8851e8c88_dw-lh-g4.webp',
  },
];

export const livingSpaces = [
  {
    t: 'Welcoming Shared Spaces',
    d: 'Lounges and dining rooms where it\u2019s easy to stop for a chat, a game or a cup of tea.',
    alt: 'Bright shared dining room with wooden tables',
    img: 'https://public.readdy.ai/ai/img_res/sandbox/d9f57693db1a3f647bcb80a40a4edde0/5fa7b452-069c-4ae4-8f43-36e8851e8c88_dw-lh-s1.webp',
  },
  {
    t: 'Moments Outdoors',
    d: 'Gardens and terraces to potter, sit in the sun or simply enjoy some fresh air.',
    alt: 'Garden terrace with seating and flower beds',
    img: 'https://public.readdy.ai/ai/img_res/sandbox/d9f57693db1a3f647bcb80a40a4edde0/5fa7b452-069c-4ae4-8f43-36e8851e8c88_dw-lh-s2.webp',
  },
  {
    t: 'Comfortable Everyday Living',
    d: 'Personal rooms made familiar with your own belongings, photographs and favourite things.',
    alt: 'Personalised bedroom with armchair and photographs',
    img: 'https://public.readdy.ai/ai/img_res/sandbox/d9f57693db1a3f647bcb80a40a4edde0/5fa7b452-069c-4ae4-8f43-36e8851e8c88_dw-lh-s3.webp',
  },
];